<template>
	<el-footer v-if="temp.show && headerMode == 0" height="initial" id="footer" class="copyright">
		<div class="wrap">
			<div class="footerlogo">
				<img :src="$store.state.app_config.system?$store.state.app_config.system.white_logo:''" class="bt_logo">
			</div>
			<div class="footerinfo" v-html="$store.state.app_config.system?$store.state.app_config.system.icp:''">
			</div>
		</div>
	</el-footer>
</template>

<script>
export default {
	name: 'footerView'
	,data () {
		return {
			temp: this.temp.footer
		}
	}
	,mounted:function(){
	}
	,methods:{
	}
	,computed:{
		headerMode(){
			return this.$store.state.layout ? this.$store.state.layout : 0
		}
	},
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/footer.vue